<script setup>
import { defineProps } from "vue";
defineProps({
  title: {
    type: String,
    default: undefined,
    required: false,
  },

  description: {
    type: String,
    default: undefined,
    required: false,
  },
});
</script>

<template>
  <div class="content-box">
    <div
      v-if="title || description"
      class="header"
      :class="{ 'with-content': !!$slots.default }"
    >
      <div v-if="title" class="title">
        {{ title }}
      </div>
      <div v-if="description" class="description">
        {{ description }}
      </div>
    </div>
    <slot />
  </div>
</template>

<style scoped lang="scss">
.content-box {
  padding: $base-space * 8 $base-space * 5;
  display: flex;
  flex-direction: column;
  background: #fff;

  .header {
    display: flex;
    flex-direction: column;
    gap: $base-space * 2;

    &.with-content {
      margin-bottom: $base-space * 6;
    }

    .title {
      @include h-2;
    }

    .description {
      @include m-text;
      color: $text-fifth;
    }
  }

  @include _md {
    border-radius: 8px;
  }
}
</style>
